import { Spacing } from '../../design-system/spacing';
import { styled } from '../../utils/styled';
import { Box } from '../Box';
import { Divider } from '../Divider';

export const StyledContainerBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'showError',
})<{ showError?: boolean }>(({ theme, showError }) => ({
  border: `1px solid ${
    showError ? theme.palette.red[600] : theme.palette.neutral[200]
  }`,
  borderRadius: theme.spacing(Spacing.Small),
  backgroundColor: theme.palette.background.paper,
}));

export const StyledDivider = styled(Divider, {
  shouldForwardProp: (prop) => prop !== 'showError',
})<{ showError?: boolean }>(({ theme, showError }) => ({
  borderColor: showError ? theme.palette.red[600] : theme.palette.neutral[200],
}));

export const StyledContainerRadio = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isExpanded',
})<{ isExpanded?: boolean }>(({ theme, isExpanded }) => ({
  display: 'flex',
  height: theme.spacing(9),
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(Spacing.Small),
  borderBottomLeftRadius: isExpanded ? 0 : theme.spacing(Spacing.Small),
  borderBottomRightRadius: isExpanded ? 0 : theme.spacing(Spacing.Small),
  justifyContent: 'space-between',
  alignItems: 'center',
}));
